import { useFormik } from "formik";
import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

interface NewCategoryModalFormProps {
  CategoryValidationSchema: any;
  onCreateNewCategory: (categoryDetails: any) => void;
  onClose: () => void;
}

const NewCategoryModalForm: React.FC<NewCategoryModalFormProps> = ({
  CategoryValidationSchema,
  onCreateNewCategory,
  onClose,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => {
    setShowModal(false);
    onClose();
  };
  const handleModalOpen = () => setShowModal(true);

  const formik = useFormik({
    initialValues: {
      categoryName: "",
    },
    validationSchema: CategoryValidationSchema,
    onSubmit: (values, { resetForm }) => {
      onCreateNewCategory(values);
      resetForm();
      handleModalClose();
    },
  });

  return (
    <>
      {
        <Button variant="primary" className="mb-3" onClick={handleModalOpen}>
          Add New Category
        </Button>
      }
      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {"Add New Category"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="category">
              <Form.Label>Category</Form.Label>
              <Form.Control
                defaultValue={""}
                type="text"
                name="categoryName"
                onChange={formik.handleChange}
                isInvalid={
                  !!(formik.touched.categoryName && formik.errors.categoryName)
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.categoryName}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => formik.handleSubmit()}>
            {"Add"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NewCategoryModalForm;
